import startTracking from '@carvana/eventable-clickstream';
import {
  ClientCookieAdapter,
  GeneralizedCookieClient,
  GeoLocationApi,
  wrapAxios
} from '@carvana/merch-geolocation';
import { axios, httpWithAuth } from '~/clients';
import { CONTACTS } from '~/constants/endpoints';
import { commonEnvironment, eventableEndpoint } from '~/constants/environment';

export default function getClientSideGeolocation(): GeoLocationApi {
  const trackData = startTracking(
    commonEnvironment,
    eventableEndpoint,
    'search',
    'search',
    '',
    {},
    false
  );

  const cookieAdapter = new ClientCookieAdapter(window.document);
  const cookieClient = new GeneralizedCookieClient(cookieAdapter);

  return new GeoLocationApi(
    cookieClient,
    {
      contactsApi: CONTACTS,
      contextApi: `${process.env.CVNA_APP_APIK_BASE_URL}/merch/carvanamerchcontextapi/api/v2/delivery/location`,
      geolocationApi: `${process.env.CVNA_APP_APIK_BASE_URL}/edge/geolocation/api/v1/geolocation`,
      onError: error => {
        import(
          /* webpackChunkName: "dd-browser-rum" */ '@datadog/browser-rum'
        ).then(({ datadogRum }) => {
          datadogRum.addError(error);
        });
        trackData({
          eventName: 'user_events_2',
          customAttributes: {
            eventName: 'Search - Geolocation - Error',
            errorData: error.message,
            errorStack: error.stack
          }
        });
      }
    },
    wrapAxios(axios),
    wrapAxios(httpWithAuth)
  );
}
